import { VDataTable } from 'vuetify/lib/components/VDataTable';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VDataTable,{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.sales,"item-key":"id","hide-default-footer":""},scopedSlots:_vm._u([{key:"item.total",fn:function({ item }){return [_vm._v("\n      "+_vm._s(_vm._f("prefix")(_vm._f("numberWithComma")(_vm._f("toFixNumber")(item.total,2)),'$'))+"\n    ")]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }